<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card color="secondary" icon="mdi-ticket-percent" :title="$t('registry_vouchers')">
          <v-layout justify-center style="flex-wrap: wrap">
            <v-radio-group row justify-center v-model="filter" @change="loadTable()">
              <v-radio :label="$t('active_m_p')" value="active"></v-radio>
              <v-radio :label="$t('all_m_p')" value="all"></v-radio>
            </v-radio-group>
            <v-btn small @click="editVoucher" color="primary">{{
              $t("create_voucher")
            }}</v-btn>
          </v-layout>
          <DataTables @editVoucher="editVoucher" @deleteVoucher="deleteVoucher" @printVoucher="printVoucher"
            :headers="headers" :tableData="tableData"></DataTables>
        </base-material-card>
        <edit-voucher ref="editVoucherDialog" @isUpdated="loadTable"></edit-voucher>

        <v-dialog class="printVoucher" v-model="dialogPrintVoucher">
          <v-card style="height: 80vh">
            <v-card-title class="text-right">
              <v-btn color="green darken-1" text @click="dialogPrintVoucher = false">{{ $t("close") }}</v-btn>
            </v-card-title>
            <v-card-text style="height: 80%">
              <a :src="printUrl">
                <embed :src="printUrl" type="application/pdf" style="height: 100%" width="100%" height="100%" />
              </a>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gestVoucher from "@/app/voucher/gestVoucher.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-vouchers",
  components: {
    DataTables,
    "edit-voucher": gestVoucher,
  },
  data() {
    return {
      filter: "active",
      dialogPrintVoucher: false,
      voucherCode: null,
      printUrl: null,
      headers: [
        { text: this.$t("voucher"), value: "code" },
        { text: this.$t("title"), value: "name" },
        { text: this.$t("active_m_s"), value: "iconActive", type: "icons" },
        { text: this.$t("type"), value: "iconType", type: "icons" },
        { text: this.$t("point"), value: "punti", type: "numeric" },
        { text: this.$t("date_inz"), value: "dateInz", type: "date" },
        { text: this.$t("date_end"), value: "dateEnd", type: "date" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    emitUpdated: function (data) {
      this._data.dialogPrintVoucher = false;
      this.loadTable();
    },
    deleteVoucher(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/voucher/deleteVoucher/" + item.code,
            { dialogLoader: true, msg: "always" }
          ).then((response) => {
            if (response.msg.esito) _.loadTable();
          });
        }
      });
    },
    editVoucher(item) {
      this.$refs.editVoucherDialog.open(item.code);
    },
    printVoucher(item) {
      this._data.printUrl = this.authorizeLink(item.printUrl);
      this._data.dialogPrintVoucher = true;
    },

    closePrintVoucher() {
      this._data.masterId = null;
      this._data.dialogPrintVoucher = false;
    },
    loadTable() {
      let _ = this;
      let url = "/auth/voucher/listVouchers";
      if (_.filter === "all") url += "/all";
      _.tableData = [];
      _.isFetching = true;
      this.chiamataAxios("GET", url).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.map(function (item) {
          item.options = [
            {
              icon: "mdi-pencil",
              color: "green",
              function: "editVoucher",
            },
            {
              icon: "mdi-printer",
              color: "primary",
              function: "printVoucher",
            },
            {
              icon: "mdi-delete",
              color: "red",
              function: "deleteVoucher",
            },
          ];
          if (item.attivo === 1)
            item.iconActive = [{ icon: "mdi-check-outline", color: "green" }];
          else item.iconActive = [{ icon: "mdi-close-outline", color: "red" }];

          item.iconType = [];
          switch (item.type) {
            case "*URL":
              item.iconType = [{ icon: "mdi-link", color: "primary" }];
              break;
            case "*TEXT":
              item.iconType = [
                { icon: "mdi-card-text-outline", color: "primary" },
              ];
              break;
            case "*POINT":
              item.iconType = [
                { icon: "mdi-ticket-percent", color: "primary" },
              ];
              break;
          }
          if (item.coordX && item.coordX != 0 && item.coordY && item.coordY != 0)
            item.iconType.push({ icon: "mdi-earth", color: "primary" });

          return item;
        });
        _.isFetching = false;
      });
    },
  },
  created() {
    this.loadTable();
  },
};
</script>
<style scoped>
.printVoucher {
  height: 80vh;
}
</style>
